import React, { useEffect, useState } from 'react';
import AlertToUIBadge from 'util/AlertToUIBadge';
import ResolveForm from './ResolveForm';

const ActiveAlerts = ({ alerts, auth, reloadData }) => {
  const [activeAlerts, setActiveAlerts] = useState(null);

  useEffect(() => {
    const activeAlertsData = alerts.map((alert, index) => {
      const data = {
        ...AlertToUIBadge(alert),
        date: alert.trigger_time,
      };

      return (
        <ResolveForm uiData={data} key={index} auth={auth} alertData={alert} reloadData={reloadData}/>
      );
    });

    setActiveAlerts(activeAlertsData);
  }, []);

  return (
    <div className='active-alerts-list'>
      <div className='side-panel-title'>Active </div>
      <div className='full-view d-flex'>
        {activeAlerts && activeAlerts.length
          ? activeAlerts
          : 'No active alerts'}
      </div>
    </div>
  );
};

export default ActiveAlerts;
